
import { useNavigate } from 'react-router-dom';

import '../styles/EmployeeMaster.css';
import CityTable from '../components/CityTable';

const City = () => {
  const navigate = useNavigate();

  const handleAddClick = () => {
    
    navigate('/city/add');
  };

  

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>City Master</h2>
        <button className="add-employee-btn" onClick={handleAddClick}>
          Add City
        </button>
      </div>

      <CityTable />
    </div>
  );
};

export default City